<template>
  <AboutUsComponents />
</template>
<script lang="ts" setup>
const {
  public: {
    featureFlags: { newAboutUs },
  },
} = useRuntimeConfig();
const AboutUsComponents = defineAsyncComponent(() =>
  newAboutUs ? import('../components/about-us-content.vue') : import('../components/about-us-legacy.vue'),
);
</script>
